
import { useContext, useState } from 'react';
import { Modal, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, DialogActions, Button, LinearProgress, TablePagination } from '@mui/material';
import { UserContext } from '../../contexts/context-layout-user';
import { useTranslation } from 'react-i18next';
import ModalDialogComponent from '../../components/dialog/dialog-component';
import { editCases } from '../../actions/cases';
import { errors } from '../../config/errors';

const formatDate = (mongoDateString) => {
  if (!mongoDateString) return '';
  const date = new Date(mongoDateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year.toString()}`;
};

export default function ModalDeleteCases() {
  const { t } = useTranslation('global')
  const { opnenRestoreCases, setOpenRestoreCases, loadCases, deletedCases, setDeletedCases } = useContext(UserContext);
  const [selected, setSelected] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    maxHeight: 'calc(100% - 100px)',
    maxWidth: '900px',
    width: 'calc(100% - 64px)',
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter(item => item !== id);
    }

    setSelected(newSelected);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const restoreCases = () => {
    setOpenMessageModal(false);
    const jsonCase = { active: true };
    editCases({ cases: selected, jsonCase })
      .then((response) => {
        if (response.status === 200) {
          const updatedDeletedCases = deletedCases.filter(caseItem => !selected.includes(caseItem._id));
          setDeletedCases(updatedDeletedCases);
          setSelected([]);
          closeModal();
          setOpenSuccessModal(true);
        } else {
          setOpenErrorModal(true);
        }
      })
      .catch(error => {
        errors.addErroLog({
          data: {
            url: window.location,
            error: error.toString(),
            message: error.message,
            file: error.file,
            line: error.line
          }
        });
        console.error(error);
      });
  }

  const closeModal = () => {
    setOpenRestoreCases(false);
    setSelected([]);
  };

  return (
    <Box>
      <Modal
        open={opnenRestoreCases}
        onClose={closeModal}
        disableAutoFocus
      >
        <Box
          sx={style}
        >
          <Typography variant='h6' component='h2' gutterBottom>
            {t('board.restoreCase.title')}
          </Typography>
          {
            loadCases ?
              <Typography variant='body1' gutterBottom>
                <LinearProgress />
              </Typography> :
              <>
                <TableContainer sx={{ maxHeight: 'calc(100vh - 300px)' }} component={Paper}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>{t('board.restoreCase.select')}</TableCell>
                        <TableCell>{t('board.restoreCase.caseName')}</TableCell>
                        <TableCell>{t('board.restoreCase.dateCase')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {deletedCases
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((caseItem, index) => (
                          <TableRow key={index}>
                            <TableCell
                              color='primary'
                              checked={selected.includes(caseItem._id)}
                              onChange={(event) => handleClick(event, caseItem._id)}
                            >
                              <Checkbox />
                            </TableCell>
                            <TableCell>{caseItem?.caseResult[0].caseName}</TableCell>
                            <TableCell>{formatDate(caseItem.creationDate)}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component='div'
                  count={deletedCases.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  style={{ position: 'relative' }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage={t('board.casesHistory.rowsPerPage')}
                >
                </TablePagination>
              </>

          }
          <DialogActions>
            <Button onClick={closeModal} color='primary'>
              {t('board.restoreCase.cancel')}
            </Button>
            <Button
              disabled={selected.length === 0}
              onClick={() => { setOpenMessageModal(true) }}
              color='primary'
            >
              {t('board.restoreCase.restore')}
            </Button>
          </DialogActions>
        </Box>
      </Modal>

      <ModalDialogComponent
        view={openMessageModal}
        tittle={t('board.restoreCase.confirm')}
        message={t('board.restoreCase.restoreDescription')}
        buttons={[
          {
            value: t('board.restoreCase.cancel'),
            onclick: () => setOpenMessageModal(false),
          },
          {
            value: t('board.restoreCase.accept'),
            color: "transparent",
            colorText: "#7220db",
            onclick: restoreCases
          }
        ]}
      />

      <Modal
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        disableAutoFocus
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '60%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'white',
            boxShadow: 24,
            padding: 4,
            borderRadius: '10px',
          }}
        >
          <Typography variant='h6' gutterBottom>
            {t('board.restoreCase.restoreCase')}
          </Typography>
          <Button
            variant='contained'
            style={{ backgroundColor: '#7220db', color: 'white' }}
            onClick={() => setOpenSuccessModal(false)}
            sx={{ marginTop: 2 }}>
            {t('board.restoreCase.accept')}
          </Button>
        </Box>
      </Modal>

      <Modal
        open={openErrorModal}
        onClose={() => setOpenErrorModal(false)}
        disableAutoFocus
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '60%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'white',
            boxShadow: 24,
            padding: 4,
            borderRadius: '10px',
          }}
        >
          <Typography variant='h6' gutterBottom>
            {t('board.restoreCase.errorUpdateCases')}
          </Typography>
          <Button
            variant='contained'
            style={{ backgroundColor: '#7220db', color: 'white' }}
            onClick={() => setOpenErrorModal(false)}
            sx={{ marginTop: 2 }}>
            {t('board.restoreCase.accept')}
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
